export var ClientIncomingCallType;
(function (ClientIncomingCallType) {
    ClientIncomingCallType[ClientIncomingCallType["OUTBOUND"] = 10] = "OUTBOUND";
    ClientIncomingCallType[ClientIncomingCallType["JOIN"] = 20] = "JOIN";
    ClientIncomingCallType[ClientIncomingCallType["INVITE"] = 30] = "INVITE";
    ClientIncomingCallType[ClientIncomingCallType["RESERVATION"] = 40] = "RESERVATION";
})(ClientIncomingCallType || (ClientIncomingCallType = {}));
//# sourceMappingURL=client-incoming-call-type.js.map